

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';
import { Vaccine } from './vaccine';
import { Medicine } from './medicine';

export interface VaccineSettingParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface VaccineSetting {
    id?: any;
    vaccineFor:string;
    ageInDesc:string;
    ageInDays:number;
    remainderDays:number;
    years:number;
    days:number;
    months:number;
    vaccineId:any;
    brandId?:any;
    tenantId: any;
    branchId: any;
    
    vaccine?: Vaccine;
    medicine?: Medicine;
    parameters?: VaccineSettingParameter[];
    links?: any;
}
export interface VaccineForOptions {
    value: string;
  } 


export abstract class VaccineSettingData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<VaccineSetting[]>;
    abstract create(url: string, data: VaccineSetting): Observable<VaccineSetting[]>;
    abstract update(url: string, data: VaccineSetting): Observable<VaccineSetting>;
    abstract delete(url: string): Observable<any>;
}
